import styled, { css } from 'styled-components';
import { IKakarikoGridStyleProps } from './types';

const msRowFallback: string[] = [];
const msColFallback: string[] = [];
for (let i = 0; i < 100; i++) {
  msRowFallback.push(`&:nth-child(${i}) {
    -ms-grid-row: ${i};
  }`);
}

for (let i = 0; i < 20; i++) {
  msColFallback.push(`> div:nth-child(${i}) {
    -ms-grid-column: ${i};
  }`);
}

export const StyledKakarikoGrid = styled.div<IKakarikoGridStyleProps>`
  ${(props: IKakarikoGridStyleProps) => {
    let { $fractionWidth } = props;
    const fr = $fractionWidth.length ? `${$fractionWidth.join('fr ')}fr` : null;

    return css`
      color: ${fr};
      display: -ms-grid;
      display: ${fr ? 'grid' : 'none'};
      -ms-grid-columns: ${fr};
      grid-template-columns: ${fr};
      max-width: 100vw;
      min-width: 700px;

      .sticky-header {
        display: contents;
        width: 100%;
      }

      > div {
        // Targets fallback grid styles for IE11
        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
          -ms-grid-column-span: ${$fractionWidth.length};
          grid-column: span ${$fractionWidth.length};
          display: -ms-grid;
          display: inline-grid;
          -ms-grid-columns: ${fr};
          grid-template-columns: ${fr};

          ${msRowFallback.join('\n')}
          ${msColFallback.join('\n')}

          .MuiCircularProgress-svg {
            display: none;
          }

          .cell {
            > *:first-child {
              max-width: 100%;
            }
          }
        }
      }
    `;
  }}
`;
